import { useRef, useState } from 'react';
import { MAX_RECORDING_TIME, SENSOR_SAMPLE_RATE } from 'util/constants';

const useRecordTimer = (limitReached: () => void) => {
  const timerInterval = useRef<NodeJS.Timeout | null>(null);
  const [timer, setTimer] = useState(0);

  const resetTimer = () => {
    setTimer(0);
  };

  const startTimer = () => {
    resetTimer();
    let start = Date.now();
    timerInterval.current = setInterval(() => {
      const now = Date.now();
      const diff = now - start;
      start = now;
      setTimer((timer) => {
        if (timer >= MAX_RECORDING_TIME) limitReached();
        return timer + diff;
      });
    }, 1000 / SENSOR_SAMPLE_RATE);
  };

  const stopTimer = () => {
    if (timerInterval.current) {
      clearInterval(timerInterval.current);
      timerInterval.current = null;
    }
  };

  return { timer, startTimer, stopTimer, resetTimer };
};

export default useRecordTimer;
